import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageHoldReasons() {
   const HOLD_OPTS = { value: 0, label: "-- Select --", active: false };
   const HOLD_MODEL = { id: 0, name: "", active: true };
   const [holdRsn, setHoldRsn] = useState(HOLD_MODEL);
   const [holdList, setHoldList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "holdReason", value: HOLD_OPTS }
   ]);
   const [editHoldRsn, setEditHoldRsn] = useState("");
   const [newHoldRsn, setNewHoldRsn] = useState("");
   const [origHoldRsn, setOrigHoldRsn] = useState("");
   const [spinHoldRsn, setSpinHoldRsn] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!holdRsn || holdRsn.id === 0)
         return; // reason was reset to initial state

      if (!editHoldRsn || editHoldRsn.length < 1)
         return; // Not editing       

      if (holdRsn.name === origHoldRsn)
         return; // No change made to reason being edited

      if (holdRsn.name.length < 3) { // Do we need this?
         toast.error("Reason description must be at least 3 characters");
         return;
      }
      UpdateHoldReason();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [holdRsn])

   function ActivateHoldReason() {
      if (!holdRsn || holdRsn.id === 0) {
         toast.error("Please select a reason to activate");
         return;
      }

      setSpinHoldRsn(true);
      api.post(`Quality/ActivateHoldReason/${holdRsn.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("QC Hold Reason activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinHoldRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinHoldRsn(false);
         });
   }

   function DeleteHoldReason() {
      setSpinHoldRsn(true);
      api.post(`Quality/DeleteHoldReason/${holdRsn.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("QC Hold Reason was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinHoldRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinHoldRsn(false);
         });
   }

   function onHoldRsnChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewHoldRsn(""); // Clear any lingering values
      if (newFilterValue.value === 0) {
         setHoldRsn(HOLD_MODEL);
         setOrigHoldRsn("");
         setEditHoldRsn("");
      }
      else { // Get the name to be edited
         const d = _.find(holdList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, holdRsn);
         changes.name = newFilterValue.label;
         changes.active = d.active;
         changes.id = newFilterValue.value;
         setHoldRsn(changes);
         setOrigHoldRsn(newFilterValue.label);
         setEditHoldRsn(newFilterValue.label);
      }
   }

   function onHoldRsnUpdate() {
      let changes = Object.assign({}, holdRsn);
      changes.name = editHoldRsn
      setHoldRsn(changes);
   }

   function runQuery() {
      setSpinHoldRsn(true);
      api
         .fetch(`Quality/GetHoldReasons`)
         .then((response) => {
            if (response.data.success) {
               const lsrList = _.concat([HOLD_OPTS],
                  _.map(response.data.reasons, (d) => ({
                     value: d.id,
                     label: d.name,
                     active: d.active
                  })));
               return { lsrList: lsrList };
            } else {
               toast.error(response.data.message);
               return { lsrList: [] };
            }
         })
         .then(({ lsrList }) => {
            setHoldList(lsrList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditHoldRsn("");
            setOrigHoldRsn("");
            setNewHoldRsn("")
            setHoldRsn(HOLD_MODEL);
            setSpinHoldRsn(false);
         });
   }

   function SaveNewHoldRsn() {
      if (!newHoldRsn || newHoldRsn.length < 1) {
         toast.error("Please provide a reason description");
         return;
      }
      if (newHoldRsn.length < 3) {
         toast.error("Reason description must be at least 3 characters");
         return;
      }
      let payload = HOLD_MODEL;
      payload.name = newHoldRsn;
      
      setSpinHoldRsn(true);
      api.post('Quality/SaveHoldReason', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("QC Hold Reason created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinHoldRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinHoldRsn(false);
         });
   }

   function UpdateHoldReason() {
      setSpinHoldRsn(true);
      api.post('Quality/SaveHoldReason', holdRsn)
         .then((response) => {
            if (response.data.success) {
               toast.success("QC Hold Reason updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinHoldRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinHoldRsn(false);
         });
   }

   const ShowHoldRsnDeleteModal = () => {
      if (!holdRsn || holdRsn.id === 0) {
         toast.error("Please select a reason");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editHoldRsn} reason?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteHoldReason() }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinHoldRsn}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {holdList && holdList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Reason:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="holdReason"
                                             options={holdList}
                                             value={filterHelpers.getValue(filters, "holdReason")}
                                             onChangeCallback={e => onHoldRsnChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
               
                     {holdRsn && holdRsn.id > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a reason that has any specification records attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive reasons will not show up in QC Hold entry options.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {holdRsn.id}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {holdRsn.active ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Reason:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editHoldRsn || ""}
                                             onChange={(e) => setEditHoldRsn(e.target.value)}
                                             maxLength="100"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onHoldRsnUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowHoldRsnDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       {!holdRsn.active ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateHoldReason()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     <br />
                     <br />
                     <hr/>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                        Add New QC Hold Reason
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Reason:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newHoldRsn || ""}
                                          onChange={(e) => setNewHoldRsn(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Reason"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewHoldRsn()}
                                       >
                                          Add Reason
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
